import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import UniversalLink from 'src/common/components/UniversalLink';
import { PATHS } from 'src/common/constants';
import getClassNames from 'src/common/utils/getClassNames';
import classNames from 'classnames';
import styles from './NoPayoutBanner.module.scss';

export type NoPayoutBannerProps = {
  hasPayoutMethod: boolean;
  hasValidPayoutCurrency: boolean;
  underline?: boolean;
};

const NoPayoutBanner: FC<NoPayoutBannerProps> = ({
  hasPayoutMethod, hasValidPayoutCurrency, underline,
}) => {
  const [t] = useTranslation('admin-common');
  if (hasPayoutMethod && hasValidPayoutCurrency) {
    return null;
  }

  return (
    <p className={getClassNames(styles, 'root', classNames({ underline }))}>
      👋
      {' '}
      {!hasValidPayoutCurrency ? t('landing-page--update-payout-banner') : t('landing-page--no-payout-banner')}
      <UniversalLink className={styles.link} href={PATHS.ADMIN_PAYMENTS}>
        {!hasValidPayoutCurrency ? t('landing-page--update-payout-currency-link') : t('landing-page--add-payout-link')}
      </UniversalLink>
    </p>
  );
};

export default NoPayoutBanner;
